/** 官网落地页文案（简体 / 繁體 / English） */
export const DETOK_LANDING_COPY = {
  'zh-CN': {
    metaTitle: 'DeTok - 让娱乐更有价值',
    nav: { features: '功能介绍', earn: '积分奖励', download: '下载App' },
    hero: {
      title: 'DeTok',
      subtitle: '让娱乐更有价值 - 看视频、玩游戏、完成任务，轻松赚取积分',
      cta: '立即下载',
      ctaSecondary: '注册',
      imgAlt: 'DeTok 预览',
    },
    featuresTitle: '丰富的功能体验',
    features: [
      { title: '精彩短视频', desc: '海量优质内容，个性化推荐，发现更多有趣的精彩视频' },
      { title: '点赞互动', desc: '为喜欢的视频点赞，关注喜欢的创作者，支持优质内容' },
      { title: '评论交流', desc: '发表你的观点，与其他用户互动讨论，分享视频感悟' },
      { title: '分享转发', desc: '一键分享精彩视频到社交平台，让更多人看到' },
      { title: '趣味游戏', desc: '内置多款休闲小游戏，娱乐消遣的同时还有机会获得奖励' },
      { title: '任务积分', desc: '完成每日任务赚取积分，积分可兑换丰富好礼' },
    ],
    earnTitleBefore: '如何赚取',
    earnTitleHighlight: '积分',
    earnSubtitle: '轻松完成日常任务，即可获得丰厚积分奖励',
    steps: [
      { title: '邀请好友', desc: '邀请新用户注册，双方各获得积分奖励' },
      { title: '每日签到', desc: '每日签到打卡，连续签到获得额外奖励' },
      { title: '观看视频', desc: '观看视频并互动，获得相应积分' },
      { title: '完成任务', desc: '完成指定任务，获取丰厚积分奖励' },
    ],
    downloadTitle: '立即下载 DeTok',
    downloadSubtitle: '开启你的价值娱乐之旅',
    ios: 'iOS 下载',
    android: 'Android 下载',
    footer: { about: '关于我们', privacy: '隐私政策', terms: '用户协议', contact: '联系我们' },
    copyright: '© 2026 DeTok. All rights reserved.',
  },
  'zh-TW': {
    metaTitle: 'DeTok - 讓娛樂更有價值',
    nav: { features: '功能介紹', earn: '積分獎勵', download: '下載 App' },
    hero: {
      title: 'DeTok',
      subtitle: '讓娛樂更有價值 - 看影片、玩遊戲、完成任務，輕鬆賺取積分',
      cta: '立即下載',
      ctaSecondary: '註冊',
      imgAlt: 'DeTok 預覽',
    },
    featuresTitle: '豐富的功能體驗',
    features: [
      { title: '精彩短影片', desc: '海量大優質內容，個人化推薦，發現更多有趣的精彩影片' },
      { title: '按讚互動', desc: '為喜歡的影片按讚，關注喜歡的創作者，支持優質內容' },
      { title: '留言交流', desc: '發表你的觀點，與其他使用者互動討論，分享影片心得' },
      { title: '分享轉發', desc: '一鍵分享精彩影片到社群平台，讓更多人看見' },
      { title: '趣味遊戲', desc: '內建多款休閒小遊戲，娛樂之餘還有機會獲得獎勵' },
      { title: '任務積分', desc: '完成每日任務賺取積分，積分可兌換豐富好禮' },
    ],
    earnTitleBefore: '如何賺取',
    earnTitleHighlight: '積分',
    earnSubtitle: '輕鬆完成日常任務，即可獲得豐厚積分獎勵',
    steps: [
      { title: '邀請好友', desc: '邀請新使用者註冊，雙方各獲得積分獎勵' },
      { title: '每日簽到', desc: '每日簽到打卡，連續簽到獲得額外獎勵' },
      { title: '觀看影片', desc: '觀看影片並互動，獲得相應積分' },
      { title: '完成任務', desc: '完成指定任務，獲取豐厚積分獎勵' },
    ],
    downloadTitle: '立即下載 DeTok',
    downloadSubtitle: '開啟你的價值娛樂之旅',
    ios: 'iOS 下載',
    android: 'Android 下載',
    footer: { about: '關於我們', privacy: '隱私權政策', terms: '使用者協議', contact: '聯絡我們' },
    copyright: '© 2026 DeTok. All rights reserved.',
  },
  en: {
    metaTitle: 'DeTok - Make Entertainment Valuable',
    nav: { features: 'Features', earn: 'Earn Points', download: 'Download' },
    hero: {
      title: 'DeTok',
      subtitle:
        'Make entertainment valuable — watch videos, play games, complete tasks, and earn points easily',
      cta: 'Download now',
      ctaSecondary: 'Sign up',
      imgAlt: 'DeTok app preview',
    },
    featuresTitle: 'Rich feature experience',
    features: [
      {
        title: 'Short videos',
        desc: 'Huge library of quality content and personalized picks — discover more great videos',
      },
      { title: 'Likes & interaction', desc: 'Like videos, follow creators you love, and support great content' },
      { title: 'Comments', desc: 'Share your thoughts, chat with others, and talk about what you watch' },
      { title: 'Share', desc: 'Share highlights to social platforms in one tap and reach more people' },
      { title: 'Fun games', desc: 'Built-in casual games — play for fun and grab extra rewards' },
      { title: 'Tasks & points', desc: 'Complete daily tasks to earn points and redeem great rewards' },
    ],
    earnTitleBefore: 'How to earn ',
    earnTitleHighlight: 'points',
    earnSubtitle: 'Finish simple daily tasks and get generous point rewards',
    steps: [
      { title: 'Invite friends', desc: 'Invite new users — both sides earn point rewards' },
      { title: 'Daily check-in', desc: 'Check in every day; streaks bring extra rewards' },
      { title: 'Watch videos', desc: 'Watch and interact to earn points' },
      { title: 'Complete tasks', desc: 'Finish missions for generous point rewards' },
    ],
    downloadTitle: 'Download DeTok now',
    downloadSubtitle: 'Start your valuable entertainment journey',
    ios: 'iOS',
    android: 'Android',
    footer: { about: 'About', privacy: 'Privacy', terms: 'Terms', contact: 'Contact' },
    copyright: '© 2026 DeTok. All rights reserved.',
  },
}

/** 官网 / 邀请落地页统一下载地址 */
export const DETOK_DOWNLOAD_URL = {
  ios: 'https://apps.apple.com/cn/app/detok/id6444339697',
  android: 'https://image.leshua.pro/flutter/apk/DeTok.apk',
}
